module.exports = __webpack_public_path__ + "img/default.ae76fb98.jpg";